import { render, staticRenderFns } from "./CoreSelectInsuranceType.vue?vue&type=template&id=12ed7a52"
import script from "./CoreSelectInsuranceType.vue?vue&type=script&lang=js"
export * from "./CoreSelectInsuranceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports